module.exports = __webpack_public_path__ + "static/media/1.c7507da1.jpeg";